import { ChartOptions } from 'chart.js';

export const doughnutWarningDiagramOptions: ChartOptions<'doughnut'> = {
  cutout: '90%',
  radius: 70,
  plugins: { legend: { display: false }, tooltip: { enabled: false } }
};
